import { Box, Button, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import FileUploadIcon from 'app/components/Icons/FileUploadIcon';
import DocumentIcon from 'app/components/Icons/DocumentIcon';
import BinIcon from 'app/components/Icons/BinIcon';
import useCustomFileUpload from 'app/components/CustomFileUpload/useCustomFileUpload';

import {
  deleteBtn,
  fileBox,
  fileDetailsBox,
  fileDetailsInfo,
  fileDetailsInfoSize,
  fileDetailsSpanInfo,
  fileSizeText,
  header,
  inputProps,
  leftSide,
  leftSideFileInfo,
  uploadBox,
} from './CustomFileUpload.sx';
import Loader from '../Loader';

interface Props {
  fileSize: string;
  withOutLabel?: boolean;
  withOutDetails?: boolean;
  name?: any;
  file?: any;
  onDrop?: any;
  deleteFile?: any;
  errorFileSize?: boolean;
  isLoading?: boolean;
  acceptedFiles?: Record<string, string[]>;
}

const FileUpload = (props: Props) => {
  const theme = useTheme();
  const { fileSize, withOutLabel, withOutDetails, file, onDrop, deleteFile, errorFileSize, isLoading, acceptedFiles } =
    props;
  const { t } = useTranslation();

  const { formatBytes, getRootProps, getInputProps } = useCustomFileUpload({ onDrop, acceptedFiles });

  return (
    <Box>
      {!withOutLabel && <Typography sx={header}>{t('commonTerms.additions')}</Typography>}
      <Box {...getRootProps()} sx={{ position: 'relative', width: '100%' }}>
        {isLoading && <Loader sx={{ position: 'absolute', left: '47%', zIndex: 1 }} />}
        <Box
          sx={{
            opacity: isLoading ? '0.5' : '1',
            ...uploadBox,
          }}
        >
          <FileUploadIcon />
          {t('commonTerms.selectFile')}
          <input type="file" {...getInputProps()} style={inputProps} />
        </Box>
      </Box>
      {!withOutDetails && (
        <Box sx={fileDetailsBox}>
          <Typography sx={fileDetailsInfo}>
            {t('commonTerms.allowedFileFormats')}
            <Typography component={'span'} sx={fileDetailsSpanInfo}>
              &nbsp;*.pdf, *.png, *.jpg/*.jpeg.
            </Typography>
          </Typography>
          <Typography sx={fileDetailsInfoSize(errorFileSize)}>
            {t('commonTerms.maxFileSize')}
            <Typography component={'span'} sx={fileDetailsSpanInfo}>
              {` ${fileSize}`}
            </Typography>
          </Typography>
        </Box>
      )}
      {file?.length > 0 &&
        file.map((item: any, index: number) => (
          <Box sx={fileBox} key={index}>
            <Box sx={leftSide}>
              <DocumentIcon />
              <Box sx={leftSideFileInfo}>
                <Typography sx={{ lineHeight: '1', fontWeight: '500' }}>{item.name}</Typography>
                <Typography sx={fileSizeText}>{formatBytes(item.size)}</Typography>
              </Box>
            </Box>
            <Button color={'tertiary'} sx={deleteBtn} onClick={() => deleteFile(item, index)}>
              <BinIcon />
            </Button>
          </Box>
        ))}
    </Box>
    // <section className="container">
    //   <div {...getRootProps({ className: 'dropzone' })}>
    //     <input {...getInputProps()} />
    //     <p>Drag n drop some files here, or click to select files</p>
    //   </div>
    //   <aside>
    //     <h4>Files</h4>
    //     <ul>{files}</ul>
    //   </aside>
    // </section>
  );
};

export default FileUpload;
